import request from "../../helpers/request";
import { TRequestFilters } from "./types";

export const getAlertasAbertos = async (
  idLoja: any,
  idCliente: number,
  idRegional: number,
  pagina: number = 1,
  itensPorPagina: number = 20,
) => {
  if (idLoja === null || idLoja === undefined) return null;

  const lojaPath = Number(idLoja);

  const url = `${process.env.REACT_APP_API}/Alerta/GetAlertasAberto/${lojaPath}?idCliente=${idCliente}&idRegional=${idRegional}&pagina=${pagina}&itensPorPagina=${itensPorPagina}`;

  console.log("Chamando URL Paginada:", url);

  const result = await request({ url });
  return result.data;
};
